// This is auto-generated by Datastar. DO NOT EDIT.
const lol = /🖕JS_DS🚀/.source
export const DSP = lol.slice(0, 5)
export const DSS = lol.slice(4)

export const DATASTAR = "datastar";
export const DATASTAR_REQUEST = "Datastar-Request";

// #region Defaults

// #region Default durations

// The default duration for retrying SSE on connection reset. This is part of the underlying retry mechanism of SSE.
export const DefaultSseRetryDurationMs = 1000;

// #endregion


// #region Default strings

// The default attributes for <script/> element use when executing scripts. It is a set of key-value pairs delimited by a newline \\n character.
export const DefaultExecuteScriptAttributes = "type module";

// #endregion


// #region Default booleans

// Should fragments be merged using the ViewTransition API?
export const DefaultFragmentsUseViewTransitions = false;

// Should a given set of signals merge if they are missing?
export const DefaultMergeSignalsOnlyIfMissing = false;

// Should script element remove itself after execution?
export const DefaultExecuteScriptAutoRemove = true;

// #endregion


// #region Enums

// The mode in which a fragment is merged into the DOM.
// Morphs the fragment into the existing element.
export const FragmentMergeModeMorph = "morph"
// Replaces the inner HTML of the existing element.
export const FragmentMergeModeInner = "inner"
// Replaces the outer HTML of the existing element.
export const FragmentMergeModeOuter = "outer"
// Prepends the fragment to the existing element.
export const FragmentMergeModePrepend = "prepend"
// Appends the fragment to the existing element.
export const FragmentMergeModeAppend = "append"
// Inserts the fragment before the existing element.
export const FragmentMergeModeBefore = "before"
// Inserts the fragment after the existing element.
export const FragmentMergeModeAfter = "after"
// Upserts the attributes of the existing element.
export const FragmentMergeModeUpsertAttributes = "upsertAttributes"

// Default value for FragmentMergeMode
export const DefaultFragmentMergeMode = FragmentMergeModeMorph;

// The type protocol on top of SSE which allows for core pushed based communication between the server and the client.
// An event for merging HTML fragments into the DOM.
export const EventTypeMergeFragments = "datastar-merge-fragments"
// An event for merging signals.
export const EventTypeMergeSignals = "datastar-merge-signals"
// An event for removing HTML fragments from the DOM.
export const EventTypeRemoveFragments = "datastar-remove-fragments"
// An event for removing signals.
export const EventTypeRemoveSignals = "datastar-remove-signals"
// An event for executing <script/> elements in the browser.
export const EventTypeExecuteScript = "datastar-execute-script"
// #endregion

// #endregion